/**
 * @desc 用户模块
 */
import { userAxios, userAxiosDirect } from '../httpInstance';
// 买方经销商详情
export function getBuyerDealerDetail(payload) {
    return userAxios({
        method: 'GET',
        url: 'buyerDetail',
        params: payload,
    });
}
// 卖方经销商详情
export function getSellerDealerDetail(payload) {
    return userAxios({
        method: 'GET',
        url: 'sellerDetail',
        params: payload,
    });
}
// desc 获取买家信息列表
export const buyerList = (params) => {
    return userAxios({
        url: 'buyerList',
        params,
    });
};
// desc 获取手机验证码
export const getVerificationCode = (params) => {
    return userAxios({
        url: 'getVerificationCode',
        params,
    });
};
// desc 校验手机验证码并添加买家
export const checkVerificationCode = (data) => {
    return userAxios({
        url: 'checkVerificationCode',
        method: 'POST',
        data,
    });
};
// desc 校验手机验证码并认证网络买家
export const checkCodeAndRealNamefromWxUser = (data) => {
    return userAxios({
        url: 'checkCodeAndRealNamefromWxUser',
        method: 'POST',
        data,
    });
};
// desc 删除号牌
export const deleteNumberPlate = (data) => {
    return userAxios({
        url: 'deleteNumberPlate',
        method: 'POST',
        data,
    });
};
// desc 删除所有号牌
export const deleteNumberPlateByTenantCode = (data) => {
    return userAxios({
        url: 'deleteNumberPlateByTenantCode',
        method: 'POST',
        data,
    });
};
// desc 编辑号牌
export const editNumberPlate = (data) => {
    return userAxios({
        url: 'editNumberPlate',
        method: 'POST',
        data,
    });
};
// desc 添加号牌
export const insertNumberPlate = (data) => {
    return userAxios({
        url: 'insertNumberPlate',
        method: 'POST',
        data,
    });
};
// desc 编辑买家信息
export const editUserMsg = (data) => {
    return userAxios({
        url: 'operationBuyerInfo',
        method: 'POST',
        data,
    });
};
// desc 获取银行卡信息
export const queryBankList = (data) => {
    return userAxios({
        url: 'queryBankList',
        method: 'get',
        params: data,
    });
};
// desc 实名认证
export const RealNameAuthenticated = (params) => {
    return userAxios({
        url: 'RealNameAuthenticated',
        params,
    });
};
// 获取卖家列表
export const queryDealerPage = (params) => {
    return userAxios({
        url: 'queryDealerPage',
        params,
    });
};
// 获取卖家列表
export const queryDealerList = (params) => {
    return userAxios({
        url: 'queryDealerList',
        params,
    });
};
// 修改是否同步买家给卖家
export const changeAsyncState = (data) => {
    return userAxios({
        url: 'changeAsyncState',
        method: 'POST',
        data,
    });
};
// 获取租户下卖家所有集团名称
export const getAllGroupName = () => {
    return userAxios({
        url: 'getAllGroupName',
    });
};
// 模糊搜索买家经销商
export function searchDealers(payload) {
    return userAxios({
        method: 'GET',
        url: 'searchDealers',
        params: payload,
    });
}
// 导出
export const globalExport = (params) => {
    return userAxiosDirect({
        url: 'userExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
// desc 用户信息获取
export const getAccount = (params) => {
    return userAxios({
        url: 'getAccount',
        params,
    });
};
// desc 修改账户信息
export const editAccount = (data) => {
    return userAxios({
        url: 'editAccount',
        method: 'POST',
        data,
    });
};
// desc 修改密码
export const changePassword = (data) => {
    return userAxios({
        url: 'changePassword',
        method: 'POST',
        data,
    });
};
// desc 退出账户
export const logout = (data) => {
    return userAxios({
        url: 'logout',
        method: 'POST',
        data,
    });
};
// desc 获取权限资源表
export function getAuthZ(payload) {
    return userAxios({
        method: 'get',
        url: 'getAuthZ',
        params: payload,
    });
}
// desc 获取分配人员列表
export function queryAccountList() {
    return userAxios({
        url: 'queryAccountList',
        params: {
            resCode: 'psgjb-carpendmine-enter',
        },
    });
}
// desc 获取租户基本信息GET /tenantInfoApi/getTenantInfoAndArea.json
export function getTenantInfoAndArea(payload) {
    return userAxios({
        method: 'get',
        url: 'getTenantInfoAndArea',
        params: payload,
    });
}
// desc 添加租户基础信息 POST /tenantInfoApi/saveTenantInfo.json
export function saveTenantInfo(data) {
    return userAxios({
        method: 'POST',
        url: 'saveTenantInfo',
        data,
    });
}
